import React from 'react';


export default class MoleculeCardTag extends React.Component {

  render() {
    let { content } = this.props;
    return (
      <span style={{
        borderBottom: '2px solid rgb(26, 198, 255)',
        padding: '0 4px',
        textTransform: 'lowercase',
        height: '13px',
        lineHeight: '13px',
        fontSize: '11px',
        fontWeight: 'normal',
/*        color: '#fff',
        backgroundColor: 'rgb(26, 198, 255)',*/
        color: '#444'
      }}>{content}</span>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/MoleculeCard/MoleculeCardTag.jsx